(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advent-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-advent-reviews]').forEach((section) => {
    const cards = Array.from(section.querySelectorAll('[data-advent-review-card]'));
    const grid = section.querySelector('.advent-reviews__grid');
    const moreButton = section.querySelector('[data-advent-reviews-more]');
    const openButton = section.querySelector('[data-advent-review-open]');
    const form = section.querySelector('[data-advent-review-form]');
    const success = section.querySelector('[data-advent-review-success]');
    const cancelButton = section.querySelector('[data-advent-review-cancel]');
    const batchSize = 8;
    const maxColumns = 4;
    const desktopColumnMin = 260;
    const desktopGap = 24;
    let columns = [];
    let activeColumnCount = 0;

    function getColumnCount() {
      if (!grid) return 1;
      if (window.matchMedia('(max-width: 749px)').matches) return 2;

      const gridWidth = grid.getBoundingClientRect().width;
      const calculatedColumns = Math.floor((gridWidth + desktopGap) / (desktopColumnMin + desktopGap));

      return Math.max(1, Math.min(maxColumns, calculatedColumns || maxColumns));
    }

    function getShortestColumn() {
      return columns.reduce((shortest, column) => {
        if (!shortest) return column;
        return column.offsetHeight < shortest.offsetHeight ? column : shortest;
      }, null);
    }

    function appendVisibleCard(card) {
      const column = getShortestColumn();

      if (column) {
        column.appendChild(card);
      }
    }

    function buildColumns() {
      if (!grid) return;

      activeColumnCount = getColumnCount();
      grid.style.setProperty('--advent-review-columns', activeColumnCount);
      grid.innerHTML = '';
      columns = [];

      for (let index = 0; index < activeColumnCount; index += 1) {
        const column = document.createElement('div');
        column.className = 'advent-reviews__column';
        column.dataset.adventReviewColumn = '';
        columns.push(column);
        grid.appendChild(column);
      }

      cards.forEach((card) => {
        if (!card.hidden) {
          appendVisibleCard(card);
        }
      });
    }

    function updateMoreButton() {
      if (!moreButton) return;
      const hasHiddenCards = cards.some((card) => card.hidden);
      moreButton.hidden = !hasHiddenCards;
    }

    if (moreButton) {
      moreButton.addEventListener('click', () => {
        cards
          .filter((card) => card.hidden)
          .slice(0, batchSize)
          .forEach((card) => {
            card.hidden = false;
            appendVisibleCard(card);
          });

        updateMoreButton();
      });
    }

    if (form) {
      if (openButton) {
        openButton.addEventListener('click', (event) => {
          event.preventDefault();
          form.hidden = false;

          if (success) {
            success.hidden = true;
          }

          form.scrollIntoView({ behavior: 'smooth', block: 'start' });

          const firstInput = form.querySelector('input, textarea, button');
          if (firstInput) {
            firstInput.focus({ preventScroll: true });
          }
        });
      }

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        form.reset();

        if (success) {
          success.hidden = false;
          success.focus();
        }
      });

      if (cancelButton) {
        cancelButton.addEventListener('click', () => {
          form.reset();
          form.hidden = true;

          if (success) {
            success.hidden = true;
          }

          if (openButton) {
            openButton.focus({ preventScroll: true });
          }
        });
      }
    }

    buildColumns();
    updateMoreButton();

    window.addEventListener('resize', () => {
      const nextColumnCount = getColumnCount();

      if (nextColumnCount !== activeColumnCount) {
        buildColumns();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seasonal-debug-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-season]').forEach((section) => {
    console.log('Seasonal collection template:', section.dataset.season);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seasonal-product-debug"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-season-product]').forEach((section) => {
    console.log('Seasonal product template:', section.dataset.seasonProduct);
  });

  } catch(e) { console.error(e); }
})();
})();
